function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15832_29648)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.2807 13.1865H16.9377V5.81836L9.71973 18.8115H15.0627V26.1797L22.2807 13.1865Z",
  fill: "#3E6295"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.61719 27.2336L7.26381 21.453L5.95919 22.7815C4.83744 20.9057 3.75 19.1034 3.75 15.9836C3.75 13.9478 4.31056 12.018 5.32869 10.2981L2.46456 10.8595L2.599 7.61914C0.936937 10.084 0 12.9821 0 15.9836C0 19.6627 1.15744 22.3046 3.05512 25.0968L1.70012 26.2183L7.61719 27.2336Z",
  fill: "#3E6295"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.7159 2.17162C21.3913 0.76575 18.7636 0 15.9999 0C12.0534 0 9.04752 1.38863 6.15984 3.65388L4.7499 2.46738L4.49902 8.51625L10.6523 7.30956L9.02721 6.07175C10.903 4.93625 12.6966 3.77744 15.9861 3.77744C17.695 3.77744 19.3358 4.16519 20.8258 4.86875L20.2158 2.17162H23.7159Z",
  fill: "#3E6295"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.7263 5.457L29.3202 4.09375H22.625L23.9598 9.99613L25.4732 8.513C26.8317 10.388 28.25 12.4489 28.25 15.9845C28.25 17.4804 27.9457 18.9438 27.3766 20.3065L29.1856 19.6338L29.5551 24.1715C31.1497 21.7383 32 18.9381 32 15.9846C32 11.624 30.3686 8.50644 27.7263 5.457Z",
  fill: "#3E6295"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.4552 22.332L21.6251 24.5L23.3362 25.6417C21.4611 26.8659 19.5796 28.1897 16.0477 28.1897C13.6368 28.1897 11.3623 27.4475 9.48555 26.125L9.6958 29.5611L7.18018 29.1294C9.7298 30.9894 12.7904 32 16.0001 32C20.3275 32 23.5442 30.3552 26.493 27.7447L27.9826 28.8067L27.4552 22.332Z",
  fill: "#3E6295"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15832_29648"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})));

var SvgEnergy = function SvgEnergy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnergy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Energy.41130b24.svg";
export { ForwardRef as ReactComponent };